import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ThemeContextProvider from "./styles/theme";
import ReferralTracker from "./services/ReferralTracker";
import AuthorizationProvider from "./hooks/Authorize";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ThemeContextProvider>
    <BrowserRouter>
      <AuthorizationProvider>
        <ReferralTracker />
        <App />
      </AuthorizationProvider>
    </BrowserRouter>
  </ThemeContextProvider>
);
